/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonAgreementInternalDTO,
  PersonAgreementInternalDTOOptional,
  PersonAgreementInternalDTOMetaI,
  PersonAgreementInternalDTOTrackedI,
} from "./person-agreement-internal-dto";
import {
  PersonAgreementInternalDTOTracked,
  PersonAgreementInternalDTOMeta,
} from "./person-agreement-internal-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonAgreementsDTO,
  PersonAgreementsDTOOptional,
  PersonAgreementsDTOMetaI,
  PersonAgreementsDTOTrackedI,
} from "./person-agreements-dto";
import {
  PersonAgreementsDTOTracked,
  PersonAgreementsDTOMeta,
} from "./person-agreements-dto";

/**
 *
 * @export
 * @interface PersonAgreementsInternalDTO
 */
export interface PersonAgreementsInternalDTOOptional extends PersonAgreementsDTOOptional {
  /**
   *
   * @type {Array<PersonAgreementInternalDTO>}
   * @memberof PersonAgreementsInternalDTO
   */
  personAgreements?: PersonAgreementInternalDTOOptional[];
}

export interface PersonAgreementsInternalDTO
  extends PersonAgreementsInternalDTOOptional, PersonAgreementsDTO {
  /**
   *
   * @type {Array<PersonAgreementInternalDTO>}
   * @memberof PersonAgreementsInternalDTO
   */
  personAgreements?: PersonAgreementInternalDTO[];
}

export interface PersonAgreementsInternalDTOTrackedI extends PersonAgreementsDTOOptional {
  /**
   *
   * @type {Array<PersonAgreementInternalDTO>}
   * @memberof PersonAgreementsInternalDTO
   */
  personAgreements?: PersonAgreementInternalDTOTrackedI[];
  personAgreementsIsSet: boolean;
}

transformDatesMap.set(
  "PersonAgreementsInternalDTO",
  function (model: PersonAgreementsInternalDTO) {
    const transformDatespersonAgreements = transformDatesMap.get(
      "PersonAgreementInternalDTO",
    );
    if (transformDatespersonAgreements) {
      model.personAgreements?.forEach((sub) => {
        transformDatespersonAgreements(sub);
      });
    }
  },
);

export type PersonAgreementsInternalDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  personAgreements: PropertyMeta<PersonAgreementInternalDTOMetaI>;
}>;

export var PersonAgreementsInternalDTOMeta: PersonAgreementsInternalDTOMetaI =
  {} as PersonAgreementsInternalDTOMetaI;
PersonAgreementsInternalDTOMeta = typeMeta("PersonAgreementsInternalDTO", {
  personAgreements: propertyMeta(
    "personAgreements",
    true,
    false,
    false,
    PersonAgreementInternalDTOMeta,
  ),
});

const metaI = PersonAgreementsInternalDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([PersonAgreementsDTOMeta]);
  metaI.personAgreements.inheritedFrom =
    PersonAgreementsDTOMeta.personAgreements;
});

export class PersonAgreementsInternalDTOTracked
  extends PersonAgreementsDTOTracked
  implements PersonAgreementsInternalDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  personAgreements__I?: PersonAgreementInternalDTOTracked[] = undefined;
  personAgreementsIsSet: boolean = false;
  set personAgreements(v: undefined | PersonAgreementInternalDTOTracked[]) {
    if (v !== undefined) {
      this.personAgreements__I = v;
      this.personAgreementsIsSet = true;
    } else {
      this.personAgreements__I = v || undefined;
      this.personAgreementsIsSet = false;
    }
    this.changeTracker = true;
  }
  get personAgreements() {
    return this.personAgreements__I;
  }
  constructor(
    config?: PersonAgreementsInternalDTOOptional,
    options?: AssignOptions,
  ) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.personAgreements?.forEach((a) => a.setIds());
  }
  assignFrom(
    config: PersonAgreementsInternalDTOOptional,
    options?: AssignOptions,
  ): PersonAgreementsInternalDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.personAgreements &&
      this.personAgreementsApplyFilter(optionsRequired.filter)
    ) {
      this.personAgreements = config.personAgreements?.map(
        (a) => new PersonAgreementInternalDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.personAgreementsIsSet = false;
      else this.personAgreementsIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PersonAgreementsInternalDTOTrackedI {
    const cloned = {} as PersonAgreementsInternalDTOTrackedI;
    if (
      this.personAgreementsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.personAgreementsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.personAgreementsIsSet = true;
      cloned.personAgreements = this.personAgreements
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.personAgreementsIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PersonAgreementsInternalDTOTrackedI {
    if (!this.personAgreementsApplyFilter(filter))
      this.personAgreementsIsSet = false;

    this.personAgreements?.forEach((a) => a.unassignAll(filter));
    return this;
  }
  personAgreementsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAgreementsInternalDTOMeta.personAgreements,
      PersonAgreementsInternalDTOMeta,
      this.personAgreements,
      this,
    );
  }
  personAgreementsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.personAgreementsIsSet && this.personAgreementsApplyFilter(filter))
      return true;

    return this.personAgreements?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.personAgreementsIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
